import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Paper from '@material-ui/core/Paper'
import styled from 'styled-components';
import ShippingCostDialog from "../addtocart/ShippingCostDialog";
import Heading from "../heading/Heading";
import {getMessage} from "../../reducers/i18n";

const PriceDisplay = (props) => {

    const StyledPaper = styled(Paper)`
        &.stolo-price-display {
            background-color: ${props => props.theme.palette.secondary.A100};
            padding: ${props => props.theme.space[3]};
            box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
            border-radius: 2px;
        }
    `;

    const PriceDisplay = styled.div`
        text-align: right;
        font-weight: 600;
        margin-right: ${(props) => props.theme.space[6]};
    `;

    const PriceSuffix = styled.div`
        display: flex;
        font-size: ${(props) => props.theme.fontSizes[7]};
        flex-wrap: wrap;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
        margin-right: ${(props) => props.theme.space[6]};
        
        & button {
          box-sizing: border-box;
          text-transform: none;
          padding: ${(props) => props.theme.space[3]};
          min-height: inherit;
        }
        
        & .stolo-price-suffix {
          padding: ${(props) => props.theme.space[2]} 0;
        }

        & .stolo-price-suffix-first {
          padding-right: ${(props) => props.theme.space[2]};
        }
    `;

    const StyledDialogHeader = styled(Heading)`
        margin: 0;
        padding: 0;
    `;

    const DialogHeader = <StyledDialogHeader level={2} text={props.shippingCostLabel}/>;
    const ShippingLabel = props.shippingIncluded === true ? <div className="stolo-price-suffix">{props.shippingIncludedSuffix}</div> : <ShippingCostDialog key="s3" label={props.shippingCostLabelPrefix + ' ' + props.shippingCostLabel} header={DialogHeader} close={props.labelClose}/>;
    const VatSuffix = props.showVat === true ? <div className="stolo-price-suffix stolo-price-suffix-first" key="s2">{props.vatPriceSuffix}</div> : null;

    const priceSuffix = [
        <PriceSuffix key="s1">
            {VatSuffix}{ShippingLabel}
        </PriceSuffix>,
    ];

    return (
        <StyledPaper classes={{ root: 'stolo-price-display' }}>
                <PriceDisplay>
                    {props.amount.toFixed( 2 )} {props.currencyUnit}
                </PriceDisplay>
                {priceSuffix}
        </StyledPaper>
    );
};

PriceDisplay.propTypes = {
    label       : PropTypes.string,
    currencyUnit: PropTypes.string,
    amount      : PropTypes.number,
    shippingIncluded: PropTypes.bool,
    showVat: PropTypes.bool,
};

PriceDisplay.defaultProps = {
    label       : '',
    currencyUnit: '€',
    amount      : 999.99,
    shippingIncluded: false,
    showVat: true,
};

const mapStateToProps = ( state, ownProps ) => {
    return {
        vatPriceSuffix: getMessage(state, "VAT_PRICE_SUFFIX"),
        shippingCostLabel: getMessage(state, "SHIPPING_COST_LABEL"),
        shippingCostLabelPrefix: getMessage(state, "SHIPPING_COST_LABEL_PREFIX"),
        shippingIncludedSuffix: getMessage(state, "SHIPPING_INCLUDED_LABEL"),
        labelClose: getMessage(state, "LABEL_CLOSE"),
        ...ownProps
    }
};

export default connect(mapStateToProps)(PriceDisplay);



// WEBPACK FOOTER //
// ./src/components/cartforms/PriceDisplay.js